// Filter state, and it lives in the URL.
//
// Same rule as the Tree's lenses: a narrowed page is a page someone will want
// to send to somebody. Nothing here is component state that a reload discards.
export const FILTERS = ["status", "school", "kind", "sacred", "evidence"];

export function readFilters(search = window.location.search) {
  const params = new URLSearchParams(search);
  const state = {};
  FILTERS.forEach((name) => {
    const value = params.get(name);
    if (value) state[name] = value;
  });
  return state;
}

export function writeFilters(filters) {
  const params = new URLSearchParams(window.location.search);
  FILTERS.forEach((name) => {
    if (filters[name]) params.set(name, filters[name]);
    else params.delete(name);
  });
  const query = params.toString();
  const url = query ? `${window.location.pathname}?${query}` : window.location.pathname;
  window.history.replaceState({}, "", url);
}

// Which facet a link answers for, in one place, so the filter and the count
// can never disagree about what "sacred" means.
const FACET_OF = {
  status: (link) => link.status,
  school: (link) => link.school?.slug,
  kind: (link) => link.relation,
  sacred: (link) => link.sacredAttestation,
  evidence: (link) => link.evidenceMode
};

export function matches(link, filters) {
  return FILTERS.every((name) => {
    const wanted = filters[name];
    return !wanted || FACET_OF[name](link) === wanted;
  });
}

export function applyFilters(groups, filters) {
  return groups
    .map((group) => ({ ...group, links: group.links.filter((link) => matches(link, filters)) }))
    .filter((group) => group.links.length > 0);
}

export function countLinks(groups) {
  return groups.reduce((total, group) => total + group.links.length, 0);
}

export function allLinks(groups) {
  return groups.flatMap((group) => group.links);
}
